import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Common.css";
import { isMobileDevice } from "../utils/deviceUtils"; // checks if the user is on a phone/tablet

function SettingsPage() {
  // Show forced "html" on mobile, otherwise read settings from local storage or default to "ask"
  const [openPreference, setOpenPreference] = useState(
    localStorage.getItem("desktopClientPreference") || "ask",
  );

  // Handle desktop client preference change and save to local browser storage
  const handlePreferenceChange = (e) => {
    const newValue = e.target.value;
    setOpenPreference(newValue);
    localStorage.setItem("desktopClientPreference", newValue);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />

      <div style={{ flex: 1 }}>
        <Container className="settings-container">
          {!isMobileDevice ? (
            <>
              <h3 className="settings-title">Settings</h3>

              <div className="settings-panel">
                <label className="settings-label">
                  Desktop Client Preference:
                </label>

                <select
                  className="form-select settings-select"
                  value={openPreference}
                  onChange={handlePreferenceChange}
                >
                  <option value="ask">Ask me every time (Default)</option>
                  <option value="html">HTML Client (In Browser)</option>
                  <option value="native">Native Client (External App)</option>
                </select>

                <small className="mt-2 d-block">
                  This setting controls how desktops open when clicked, either
                  directly in the browser or in an external native client
                  application.
                </small>
              </div>
            </>
          ) : (
            <h3 className="settings-title">
              Settings are not available on mobile devices (HTML client is
              forced).
            </h3>
          )}
        </Container>
      </div>
      <Footer />
    </div>
  );
}

export default SettingsPage;
